import axios from '../../axios/axiosdb';
import * as actionTypes from './actionTypes';
import {getRandomId, listOfCommentsFromResponse} from "../../Utils/utils";

const postCommentInit = () => {
    return {
        type: actionTypes.POST_COMMENT_INIT
    }
}

const postCommentStart = () => {
    return {
        type: actionTypes.POST_COMMENT_START
    }
}

const postCommentSuccess = (comments) => {
    return {
        type: actionTypes.POST_COMMENT_SUCCESS,
        comments
    }
}

const postCommentFail = (error) => {
    return {
        type: actionTypes.POST_COMMENT_FAIL,
        error
    }
}

export const postComment = (url) => {
    return dispatch => {
        dispatch(postCommentInit())
        dispatch(postCommentStart())
        axios
            .get(url)
            .then(response => {
                const comments = listOfCommentsFromResponse(response)
                dispatch(postCommentSuccess(comments))
            })
            .catch(error => {
                console.log(error)
                dispatch(postCommentFail(error))
            })
    }
}

const postCommentToggleUpVoteSuccess = (id, commentId, flag) => {
    return {
        type: actionTypes.POST_COMMENT_TOGGLE_UPVOTE_SUCCESS,
        id,
        flag
    }
}

export const postCommentToggleUpVote = (id, commentId, postId, commentOwnerUserId, upVoteUserId, points, flag, token) => {
    return dispatch => {
        dispatch(postCommentToggleUpVoteSuccess(id, commentId, flag))
        // TODO Rest api call to backend for updating the upvote
        // TODO On failed api call update the upvote

        const authToken = "?auth=" + token
        const point = flag ? -1 : 1
        const totalPoints = +points + point

        axios.put("/comments/" + commentId + "/points.json" + authToken, totalPoints.toString())
        axios.put("/comments/" + commentId + "/upVoteBy/" + upVoteUserId + ".json" + authToken, point)

        axios.put("/postcomments/" + postId + "/" + commentId + "/points.json" + authToken, totalPoints.toString())
        axios.put("/postcomments/" + postId + "/" + commentId + "/upVoteBy/" + upVoteUserId + ".json" + authToken, point)

    }
}


const postCommentSubmitStart = () => {
    return {
        type: actionTypes.POST_COMMENT_SUBMIT_START
    }
}

const postCommentSubmitSuccess = (comment, commentId) => {
    return {
        type: actionTypes.POST_COMMENT_SUBMIT_SUCCESS,
        comment,
        commentId
    }
}

const postCommentSubmitFail = (error) => {
    return {
        type: actionTypes.POST_COMMENT_SUBMIT_FAIL,
        error
    }
}

export const postCommentSubmit = (postId, commentData, postOwnerUserId, comments, token) => {
    return dispatch => {
        dispatch(postCommentSubmitStart())

        const authToken = "?auth=" + token
        const commentId = getRandomId()
        axios
            .put("/postcomments/" + postId + "/" + commentId + ".json" + authToken, commentData)
            .then(response => {
                //console.log(response)
                dispatch(postCommentSubmitSuccess(commentData, commentId))
            })
            .catch(error => {
                console.log(error)
                dispatch(postCommentSubmitFail(error))
            })

        axios
            .put("/comments/" + commentId + ".json" + authToken, commentData)
            .then(response => {
                //console.log(response)
            })
            .catch(error => {
                console.log(error)
            })

        axios.put("/posts/" + postId + "/comments.json" + authToken, comments + 1)
        axios.put("/userposts/" + postOwnerUserId + "/" + postId + "/comments.json" + authToken, comments + 1)
    }
}